import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TranslatableString } from '@rjsf/utils';
import { List, ListIcon, ListItem, Alert, AlertTitle } from '@chakra-ui/react';
import { WarningIcon } from '@chakra-ui/icons';
export default function ErrorList({ errors, registry, }) {
    const { translateString } = registry;
    return (_jsxs(Alert, { flexDirection: 'column', alignItems: 'flex-start', gap: 3, status: 'error', children: [_jsx(AlertTitle, { children: translateString(TranslatableString.ErrorsLabel) }), _jsx(List, { children: errors.map((error, i) => (_jsxs(ListItem, { children: [_jsx(ListIcon, { as: WarningIcon, color: 'red.500' }), error.stack] }, i))) })] }));
}
//# sourceMappingURL=ErrorList.js.map